import dayjs from 'dayjs';
import _ from 'lodash';
import { FlightSearchTypes, InitialFormValidations } from '../../../../constants';

const validateFlightSearchInputs = (
  setFormValidations, leadDays, flightSearchType,
  searchInputs, doShowValidationErrors = true, isCheckAvailability = false,
  segmentIndex,
) => {
  const validationObj = JSON.parse(JSON.stringify(InitialFormValidations));
  const isDirectSell = flightSearchType === FlightSearchTypes.DIRECT_SELL;
  let isValid = true;
  if (!searchInputs) return false;
  if (!searchInputs.flightSegments || !searchInputs.flightSegments.length) {
    validationObj.flightSegments[0] = {
      origin: 'Flight origin is required.',
    };
    isValid = false;
  } else if (searchInputs.flightSegments.length === 1
    && flightSearchType === FlightSearchTypes.MULTI_CITY) {
    validationObj.flightSegments[1] = {
      origin: 'Flight destination is required.',
    };
    isValid = false;
  }
  const start = isCheckAvailability ? segmentIndex : 0;
  const end = isCheckAvailability ? segmentIndex + 1 : searchInputs.flightSegments.length;
  for (let index = start; index < end; index += 1) {
    const fs = searchInputs.flightSegments[index];
    if (searchInputs.flightSearchType === FlightSearchTypes.ROUND_TRIP && index > 0) {
      if (!fs.leaveDate) {
        validationObj.flightSegments[index] = {
          returnDate: 'Return date is required.',
        };
        isValid = false;
      }
      break;
    }
    if (!fs.origin || (!fs.origin.airportCode && !fs.origin.value)) {
      validationObj.flightSegments[index] = {
        origin: 'Flight origin is required.',
      };
      isValid = false;
      break;
    } else if (!fs.destination
      || (!fs.destination.airportCode && !fs.destination.value
          && !(fs.destination.latitude && fs.destination.longitude))) {
      validationObj.flightSegments[index] = {
        destination: 'Flight destination is required.',
      };
      isValid = false;
      break;
    } else if (!fs.leaveDate && !isDirectSell) {
      validationObj.flightSegments[index] = {
        leaveDate: 'Leave date is required.',
      };
      isValid = false;
      break;
    }

    // Lead day validations based on user status
    const today = dayjs().startOf('day');
    const minCheckInDate = today.add(leadDays, 'day');

    if (isDirectSell) {
      if (_.isEmpty(fs.departureDate)) {
        validationObj.flightSegments[index] = { departureDate: 'Departure date is required' };
        isValid = false;
        break;
      } else if (dayjs(fs.departureDate).isBefore(today)) {
        validationObj.flightSegments[index] = {
          departureDate: 'Departure date cannot be earlier than today',
        };
        isValid = false;
        break;
      } else if (dayjs(fs.departureDate).isBefore(minCheckInDate)) {
        validationObj.flightSegments[index] = {
          departureDate: `Departure date cannot be earlier than ${leadDays} ${leadDays === 1 ? 'day' : 'days'} from today.`,
        };
        isValid = false;
        break;
      } else if (_.isEmpty(fs.carrierCode)) {
        validationObj.flightSegments[index] = { carrierCode: 'Airline code is required' };
        isValid = false;
        break;
      } else if (_.isEmpty(fs.flightNumber)) {
        validationObj.flightSegments[index] = { flightNumber: 'Flight number is required' };
        isValid = false;
        break;
      } else if (_.isEmpty(fs.cabin) && !isCheckAvailability) {
        validationObj.flightSegments[index] = { cabin: 'Cabin is required' };
        isValid = false;
        break;
      }
    } else {
      if (dayjs(fs.leaveDate).isBefore(today)) {
        validationObj.flightSegments[index] = {
          leaveDate: 'Leave date cannot be earlier than today',
        };
        isValid = false;
        break;
      }
      if (dayjs(fs.leaveDate).isBefore(minCheckInDate)) {
        validationObj.flightSegments[index] = {
          leaveDate: `Leave date cannot be earlier than ${leadDays} ${leadDays === 1 ? 'day' : 'days'} from today.`,
        };
        isValid = false;
        break;
      }
    }
  }

  if (doShowValidationErrors) setFormValidations(validationObj);
  return isValid;
};

export default validateFlightSearchInputs;
